export const colors = {
    primary: '#8E48E2',
    secondary:'#BBA7EF'
}

export const API_KEY = 'AIzaSyA803tGWjqiLXlzocmqqM0vqGyHxT2yOI0';
